import { autoinject } from 'aurelia-framework';
import { PenOfferStatusDto } from 'models/pen/PenOfferStatus';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class PenOfferStatusService extends BaseApiService<PenOfferStatusDto> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, PenOfferStatusDto);
  }
}
